/**
 * @author      xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { ButtonSize } from '../constants'

import * as styles from './styles'

export const getSizeStyle = (size: ButtonSize | undefined) => {
  switch (size) {
    case 'bg':
      return styles.big
    case 'md':
      return styles.medium
    case 'sm':
      return styles.small
    case 'xs':
      return styles.small
    default:
      return null
  }
}

export const getSpaceSizeStyle = (size: ButtonSize | undefined) => {
  switch (size) {
    case 'bg':
      return styles.spacesBig
    case 'md':
      return styles.spacesMedium
    case 'sm':
      return styles.spacesSmall
    case 'xs':
      return styles.spacesSmall
    default:
      return null
  }
}
